import { useMemo } from "react";

import type { Margin } from "~/v2/api/rest/account";
import { getPrettyCash } from "~/v2/utils/formatting";

interface GetCryptoBuyingPowerParams {
  margin: Margin | undefined;
}

export const getCryptoBuyingPower = ({
  margin,
}: GetCryptoBuyingPowerParams): {
  nonMarginBuyingPower: string;
} => {
  const nonMarginBuyingPower = getPrettyCash(
    margin?.non_marginable_buying_power || "0",
    {
      withPrefix: false,
    },
  );

  return { nonMarginBuyingPower };
};

export const useCryptoBuyingPower = ({
  margin,
}: GetCryptoBuyingPowerParams) => {
  return useMemo(() => getCryptoBuyingPower({ margin }), [margin]);
};
